import AixeloLogo from '../../images/AixeloBanner.jpg';
import { Workbook } from 'exceljs';


export async function exportCandiatesTemplateXLS(factors, subscores, cycle, filename) {

    const img = new Image();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const imageBase64 = canvas.toDataURL('image/jpeg').split(',')[1]; // Extract base64 string

        // ADD THE AIXELO LOGO
        const logo = workbook.addImage({
            base64: imageBase64,
            extension: 'jpg',
        });

         // Calculate aspect ratio
        const aspectRatio = img.width / img.height;
        const RatioXlsRow2Col = 192./60.
        const widthInPixels = 50; // Example width in pixels
        const heightInPixels = widthInPixels/aspectRatio*RatioXlsRow2Col; // Example height in pixels

        worksheet.addImage(logo, {
            tl: { col: 0, row: 0 },
            br: { col: widthInPixels / 2.8, row: heightInPixels / 2.8}, // Divide by 10 to convert pixels to Excel units (1/10th of a point)
            editAs: 'oneCell',
        });        


        // ADD HEADER TEXT TO XLS FILE
        const headerText = `This file was automatically generated by Aixelo Edison-4.0 Optimization Planner\n`;
        const additionalText = ['You can use this file for data upload.',
                                'Just fill in the values for the subscores.',
                                'If applicable, adjust the factor values to what was actually measured.'];


        // Add header text to cell A10
        const headerCell = worksheet.getCell('A5');
        headerCell.value = headerText;
        headerCell.font = {
        name: 'Calibri',
        size: 12,
        bold: true,
        italic: true,
        };

        // Add additional text to consecutive cells starting from A12
        additionalText.forEach((line, index) => {
            const cell = worksheet.getCell(`A${6 + index}`);
            cell.value = line;
            cell.font = {
            name: 'Calibri',
            size: 11,
            bold: false,
            italic: true, // Set the font to italic
            };
        });

        // EXPORT THE CSV CONTENT
        let tableHeader = [];
        factors.forEach((factor) => {
            if (factor.units==='') {
                tableHeader.push(`${factor.name}`);
            }
            else{
                tableHeader.push(`${factor.name} [${factor.units}]`);
            }

        });
        subscores.forEach((score) => {
            if (score.units==='') {
                tableHeader.push(`${score.name}`)
            }
            else{
                tableHeader.push(`${score.name} [${score.units}]`)
            }
        });

        tableHeader.forEach((header, columnIndex) => {
            // Iterate through each column header
            const cell = worksheet.getCell(`${String.fromCharCode(65 + columnIndex)}10`);
            // Set the cell value to the column header
            cell.value = header;
            // Set font properties
            cell.font = {
                name: 'Calibri',
                size: 11,
                bold: true,
                italic: false, // Set the font to italic
            };
        });


        cycle.selected_candidates.forEach ((candidate, cand_id) => {
            candidate.factors.forEach( (factor, factor_id) => {
                // Iterate through each column header
                const cell = worksheet.getCell(`${String.fromCharCode(65 + factor_id)}${11 + cand_id}`);
                // Set the cell value to the column header
                cell.value = factor;
                // Set font properties
                cell.font = {
                    name: 'Calibri',
                    size: 11,
                    bold: false,
                    italic: false, // Set the font to italic
                };
            });
        });

        // SAVE TO WORKBOOK
        workbook.xlsx.writeBuffer().then(function (data) {
            // Create a Blob from the data
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
    
            // Create a link element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
    
            // Clean up
            window.URL.revokeObjectURL(url);
        }).catch(function (error) {
            console.error('Error occurred while creating Excel file:', error);
        });
    };

    // Set the image source
    img.src = AixeloLogo;
}




export async function exportCandiatesTableXLS(factors, cycle, filename) {

    const img = new Image();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const imageBase64 = canvas.toDataURL('image/jpeg').split(',')[1]; // Extract base64 string

        // ADD THE AIXELO LOGO
        const logo = workbook.addImage({
            base64: imageBase64,
            extension: 'jpg',
        });

         // Calculate aspect ratio
        const aspectRatio = img.width / img.height;
        const RatioXlsRow2Col = 192./60.
        const widthInPixels = 50; // Example width in pixels
        const heightInPixels = widthInPixels/aspectRatio*RatioXlsRow2Col; // Example height in pixels

        worksheet.addImage(logo, {
            tl: { col: 0, row: 0 },
            br: { col: widthInPixels / 2.8, row: heightInPixels / 2.8}, // Divide by 10 to convert pixels to Excel units (1/10th of a point)
            editAs: 'oneCell',
        });        

        // ADD HEADER TEXT TO XLS FILE
        const headerText = `This file was automatically generated by Aixelo Edison-4.0 Optimization Planner\n`;
       
        // Add header text to cell A10
        const headerCell = worksheet.getCell('A5');
        headerCell.value = headerText;
        headerCell.font = {
        name: 'Calibri',
        size: 12,
        bold: true,
        italic: true,
        };

        // EXPORT THE CSV CONTENT
        let tableHeader = [];
        factors.forEach((factor) => {
            if (factor.units==='') {
                tableHeader.push(`${factor.name}`);
            }
            else{
                tableHeader.push(`${factor.name} [${factor.units}]`);
            }
        });
        tableHeader.push("Strategy");
        tableHeader.push("predicted total_score");
        tableHeader.push("stddev (total_score)");
        tableHeader.forEach((header, columnIndex) => {
            // Iterate through each column header
            const cell = worksheet.getCell(`${String.fromCharCode(65 + columnIndex)}7`);
            // Set the cell value to the column header
            cell.value = header;
            // Set font properties
            cell.font = {
                name: 'Calibri',
                size: 11,
                bold: true,
                italic: false, // Set the font to italic
            };
        });

        cycle.selected_candidates.forEach((candidate, cand_id) => {
            candidate.factors.forEach((factor, factor_id) => {
                // Calculate the cell reference for the factor columns
                const cell = worksheet.getCell(`${String.fromCharCode(65 + factor_id)}${8 + cand_id}`);
                // Set the cell value to the factor value
                cell.value = factor;
                // Set the cell font properties
                cell.font = {
                    name: 'Calibri',
                    size: 11,
                    bold: false,
                    italic: false,
                };
            });
        
            // Calculate the column for the strategy (next column after factors)
            const strategyColumnIndex = candidate.factors.length; // Next column index after all factors
            const strategyCell = worksheet.getCell(`${String.fromCharCode(65 + strategyColumnIndex)}${8 + cand_id}`);
            
            // Set the value of the strategy cell
            strategyCell.value = candidate.strategy;
            strategyCell.font = {
                name: 'Calibri',
                size: 11,
                bold: false, 
                italic: false,
            };
            const meanCell = worksheet.getCell(`${String.fromCharCode(65 + strategyColumnIndex+1)}${8 + cand_id}`);
            // Set the value of the strategy cell
            meanCell.value = candidate.mean;
            meanCell.font = {
                name: 'Calibri',
                size: 11,
                bold: false, 
                italic: false,
            };
            const stddevCell = worksheet.getCell(`${String.fromCharCode(65 + strategyColumnIndex+2)}${8 + cand_id}`);
            // Set the value of the strategy cell
            stddevCell.value = candidate.stddev;
            stddevCell.font = {
                name: 'Calibri',
                size: 11,
                bold: false, 
                italic: false,
            };
        });

        // SAVE TO WORKBOOK
        workbook.xlsx.writeBuffer().then(function (data) {
            // Create a Blob from the data
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
    
            // Create a link element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
    
            // Clean up
            window.URL.revokeObjectURL(url);
        }).catch(function (error) {
            console.error('Error occurred while creating Excel file:', error);
        });
    };

    // Set the image source
    img.src = AixeloLogo;
}


export async function exportColumns2XLS(csv_columns, filename) {

    const img = new Image();
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const imageBase64 = canvas.toDataURL('image/jpeg').split(',')[1]; // Extract base64 string

        // ADD THE AIXELO LOGO
        const logo = workbook.addImage({
            base64: imageBase64,
            extension: 'jpg',
        });

         // Calculate aspect ratio
        const aspectRatio = img.width / img.height;
        const RatioXlsRow2Col = 192./60.
        const widthInPixels = 50; // Example width in pixels
        const heightInPixels = widthInPixels/aspectRatio*RatioXlsRow2Col; // Example height in pixels

        worksheet.addImage(logo, {
            tl: { col: 0, row: 0 },
            br: { col: widthInPixels / 2.8, row: heightInPixels / 2.8}, // Divide by 10 to convert pixels to Excel units (1/10th of a point)
            editAs: 'oneCell',
        });        

        // ADD HEADER TEXT TO XLS FILE
        const headerText = `This file was automatically generated by Aixelo Edison-4.0 Optimization Planner\n`;
       
        // Add header text to cell A10
        const headerCell = worksheet.getCell('A5');
        headerCell.value = headerText;
        headerCell.font = {
        name: 'Calibri',
        size: 12,
        bold: true,
        italic: true,
        };

        // EXPORT THE CSV CONTENT
        let tableHeader = [];
        csv_columns.forEach((column) => {
            if (column.units==='') {
                tableHeader.push(`${column.name}`);
            }
            else{
                tableHeader.push(`${column.name} [${column.units}]`);
            }
        });
        tableHeader.forEach((header, columnIndex) => {
            // Iterate through each column header
            const cell = worksheet.getCell(`${String.fromCharCode(65 + columnIndex)}7`);
            // Set the cell value to the column header
            cell.value = header;
            // Set font properties
            cell.font = {
                name: 'Calibri',
                size: 11,
                bold: true,
                italic: false, // Set the font to italic
            };
        });

        csv_columns.forEach((column, col_id) => {
            column.vals.forEach((col_val, col_val_id) => {
                // Calculate the cell reference for the factor columns
                const cell = worksheet.getCell(`${String.fromCharCode(65 + col_id)}${8 + col_val_id}`);
                // Set the cell value to the factor value
                cell.value = col_val;
                // Set the cell font properties
                cell.font = {
                    name: 'Calibri',
                    size: 11,
                    bold: false,
                    italic: false,
                };
            });
        });

        // SAVE TO WORKBOOK
        workbook.xlsx.writeBuffer().then(function (data) {
            // Create a Blob from the data
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
    
            // Create a link element to trigger the download
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
    
            // Clean up
            window.URL.revokeObjectURL(url);
        }).catch(function (error) {
            console.error('Error occurred while creating Excel file:', error);
        });
    };

    // Set the image source
    img.src = AixeloLogo;

}

